import { render, staticRenderFns } from "./campaignColorBasic.vue?vue&type=template&id=99170f26&scoped=true&"
import script from "./campaignColorBasic.vue?vue&type=script&lang=js&"
export * from "./campaignColorBasic.vue?vue&type=script&lang=js&"
import style0 from "./campaignColorBasic.vue?vue&type=style&index=0&id=99170f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99170f26",
  null
  
)

export default component.exports